exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#devmg[data-v-65572c8a]{padding-top:20px;width:100%}.el-table[data-v-65572c8a]{margin:20px auto}.el-table .warning-row[data-v-65572c8a]{background:oldlace}.el-table .success-row[data-v-65572c8a]{background:#f0f9eb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65572c8a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/nodemg.vue
// module id = 247
// module chunks = 0